var _path, _path2, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 130,
    viewBox: "0 0 131 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.6652 116.441C90.9898 118.025 115.236 96.3479 116.82 68.0232C118.404 39.6986 96.7267 15.4526 68.4021 13.8684C40.0774 12.2842 15.8315 33.9617 14.2473 62.2863C12.6631 90.611 34.3405 114.857 62.6652 116.441Z",
    stroke: "#FF4E4E",
    strokeWidth: 6.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.401 62.0192C52.8261 62.5167 53.4293 62.8277 54.0811 62.8855C54.733 62.9432 55.3814 62.743 55.8873 62.328L60.2246 58.6965C60.7221 58.2714 61.0331 57.6682 61.0909 57.0163C61.1486 56.3645 60.9485 55.716 60.5334 55.2101L51.9766 44.9904C54.8547 43.9833 57.9713 43.8772 60.9111 44.6863C63.851 45.4953 66.4745 47.1811 68.432 49.519C70.3894 51.8569 71.5879 54.7358 71.8677 57.7721C72.1475 60.8084 71.4953 63.8579 69.9981 66.5141L85.6817 85.2458C86.5847 86.3242 87.0222 87.7172 86.8981 89.1182C86.774 90.5192 86.0985 91.8136 85.0201 92.7165C83.9416 93.6195 82.5487 94.057 81.1477 93.933C79.7466 93.8089 78.4523 93.1333 77.5493 92.0549L61.8657 73.3233C58.9876 74.3304 55.871 74.4365 52.9311 73.6274C49.9913 72.8183 47.3678 71.1325 45.4103 68.7946C43.4528 66.4567 42.2544 63.5778 41.9746 60.5415C41.6948 57.5052 42.347 54.4557 43.8442 51.7995L52.3783 61.9921L52.401 62.0192Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 107.726,
    y1: 36.1492,
    x2: 30.726,
    y2: 103.149,
    stroke: "#FF4E4E",
    strokeWidth: 11
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureDisabled);
export default __webpack_public_path__ + "static/media/feature_disabled.2c1a1b136e9595ec4b6baf0b9eab1a2e.svg";
export { ForwardRef as ReactComponent };